export interface GetSupportUserIssue {
  issueId: string
}

export interface GetSupportUserIssueComments extends GetSupportUserIssue {}
export interface GetSupportUserIssueAttachments extends GetSupportUserIssue {}
export interface CreateSupportUserIssueComment extends GetSupportUserIssue {}
export interface UpdateSupportUserIssueStatusParams extends GetSupportUserIssue {}

const endpoints = {
  getUserIssues: 'api/v2/users/user-id/issues/',
  createAppeal: 'api/v2/users/user-id/issues/',
  updateIssueStatus: ({ issueId }: UpdateSupportUserIssueStatusParams) =>
    `api/v2/users/user-id/issues/${issueId}/status`,
  getUserIssue: ({ issueId }: GetSupportUserIssue) => `api/v2/users/user-id/issues/${issueId}`,
  getUserIssueComments: ({ issueId }: GetSupportUserIssueComments) => `api/v2/users/user-id/issues/${issueId}/comments`,
  createIssueComment: ({ issueId }: CreateSupportUserIssueComment) => `api/v2/users/user-id/issues/${issueId}/comments`,
  getUserIssueAttachments: ({ issueId }: GetSupportUserIssueAttachments) =>
    `api/v2/users/user-id/issues/${issueId}/attachments`,
}

export default endpoints
